import { render } from "./SamlDomainSwitcher.vue?vue&type=template&id=443635e8&scoped=true"
import script from "./SamlDomainSwitcher.vue?vue&type=script&lang=js"
export * from "./SamlDomainSwitcher.vue?vue&type=script&lang=js"

import "./SamlDomainSwitcher.vue?vue&type=style&index=0&id=443635e8&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443635e8"]])

export default __exports__